import { ScanLine, Share2 } from "lucide-react";

export default function ScanToVisit() {
  return (
    <section
      data-testid="scan-section"
      className="relative py-20 lg:py-24 bg-cream"
    >
      <div className="mx-auto max-w-5xl px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-[36px] bg-forest text-cream p-8 sm:p-12 lg:p-16 aw-shadow-lg">
          <div
            aria-hidden
            className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[#8A9A86]/25 blur-3xl"
          />
          <div
            aria-hidden
            className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-[#D8B4A0]/25 blur-3xl"
          />

          <div className="relative grid sm:grid-cols-[auto_1fr] items-center gap-10 lg:gap-14">
            <div className="justify-self-center sm:justify-self-start">
              <div className="rounded-3xl bg-cream p-4 aw-shadow">
                <img
                  src="/align-wellness-qr.png"
                  alt="QR code to visit alignwithtammy.com"
                  data-testid="scan-qr-image"
                  className="h-44 w-44 sm:h-52 sm:w-52 block"
                  width="208"
                  height="208"
                />
              </div>
            </div>

            <div className="text-center sm:text-left">
              <p className="text-[11px] tracking-eyebrow uppercase text-cream/60 mb-4 flex items-center gap-2 justify-center sm:justify-start">
                <ScanLine size={14} className="text-[#D8B4A0]" />
                Scan to visit
              </p>
              <h2
                data-testid="scan-headline"
                className="font-serif-display text-cream text-4xl sm:text-5xl leading-[1.05] tracking-tight"
              >
                Take Align Wellness
                <br />
                <span className="italic">with you.</span>
              </h2>
              <p className="mt-4 text-cream/75 text-base sm:text-lg leading-relaxed max-w-md mx-auto sm:mx-0">
                Point your phone camera at the code to open
                alignwithtammy.com — or screenshot &amp; share this with a
                friend who&apos;s ready to heal, release, and rise.
              </p>
              <div className="mt-8 flex flex-wrap items-center gap-3 justify-center sm:justify-start">
                <a
                  href="/align-wellness-qr.png"
                  download="alignwithtammy-qr.png"
                  data-testid="scan-download-brand"
                  className="inline-flex items-center gap-2 rounded-full bg-cream text-forest px-6 py-3 text-xs tracking-[0.18em] uppercase transition-all duration-500 hover:bg-[#D8B4A0]"
                >
                  <Share2 size={14} />
                  Download QR
                </a>
                <a
                  href="/align-wellness-qr-bw.png"
                  download="alignwithtammy-qr-bw.png"
                  data-testid="scan-download-bw"
                  className="inline-flex items-center gap-2 rounded-full border border-cream/40 text-cream px-6 py-3 text-xs tracking-[0.18em] uppercase transition-all duration-500 hover:bg-cream hover:text-forest"
                >
                  Print version
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
